// FAKE DATA
export const magicItems = [
  {
    id: 1,
    title: "Talisman of Ultimate Evil",
    url: "https://www.dndbeyond.com/avatars/thumbnails/7/444/1000/1000/636284775126444275.jpeg",
    originalPrice: 399.99,
    salePrice: 220.99,
    rating: 5,
    description:
      "This item symbolizes unrepentant evil. A creature that is neither good nor evil in alignment takes 6d6 necrotic damage upon touching the talisman. A good creature takes 8d6 necrotic damage upon touching the talisman. Either sort of creature takes the damage again each time it ends its turn holding or carrying the talisman.",
  },
  {
    id: 2,
    title: "Flame Tongue",
    url: "https://www.dndbeyond.com/avatars/thumbnails/7/219/1000/1000/636284733648450283.jpeg",
    originalPrice: 89.99,
    salePrice: null,
    rating: 4,
    description:
      "You can use a bonus action to speak this magic sword's command word, causing flames to erupt from the blade. These flames shed bright light in a 40-foot radius and dim light for an additional 40 feet. While the sword is ablaze, it deals an extra 2d6 fire damage to any target it hits. The flames last until you use a bonus action to speak the command word again or until you drop or sheathe the sword.",
  },
  {
    id: 3,
    title: "Headband of Intellect",
    url: "https://www.dndbeyond.com/avatars/thumbnails/7/243/1000/1000/636284738487464526.jpeg",
    originalPrice: 34.99,
    salePrice: null,
    rating: 3.5,
    description:
      "Your Intelligence score is 19 while you wear this headband. It has no effect on you if your Intelligence is 19 or higher without it.",
  },
  {
    id: 4,
    title: "Robe of Stars",
    url: "https://www.dndbeyond.com/avatars/thumbnails/7/380/1000/1000/636284763972311694.jpeg",
    originalPrice: 299.99,
    salePrice: 180.99,
    rating: 4.5,
    description:
      "This black or dark blue robe is embroidered with small white or silver stars. You gain a +1 bonus to saving throws while you wear it. Six stars, located on the robe's upper front portion, are particularly large. While wearing this robe, you can use an action to pull off one of the stars and use it to cast magic missile as a 5th-level spell. Daily at dusk, 1d6 removed stars reappear on the robe. While you wear the robe, you can use an action to enter the Astral Plane along with everything you are wearing and carrying. You remain there until you use an action to return to the plane you were on. You reappear in the last space you occupied, or if that space is occupied, the nearest unoccupied space.",
  },
  {
    id: 5,
    title: "Staff of the Magi",
    url: "https://www.dndbeyond.com/avatars/thumbnails/7/422/1000/1000/636284770290048212.jpeg",
    originalPrice: 169.99,
    salePrice: null,
    rating: 4.5,
    description: "This staff can be wielded as a magic quarterstaff that grants a +2 bonus to attack and damage rolls made with it. While you hold it, you gain a +2 bonus to spell attack rolls. The staff has 50 charges for the following properties. It regains 4d6 + 2 expended charges daily at dawn. If you expend the last charge, roll a d20. On a 20, the staff regains 1d12 + 1 charges.",
  },
  {
    id: 6,
    title: "Tome of Understanding",
    url: "https://www.dndbeyond.com/avatars/thumbnails/7/454/1000/1000/636284778493388654.jpeg",
    originalPrice: 269.99,
    salePrice: 150.99,
    rating: 5,
    description: "This book contains intuition and insight exercises, and its words are charged with magic. If you spend 48 hours over a period of 6 days or fewer studying the book's contents and practicing its guidelines, your Wisdom score increases by 2, as does your maximum for that score. The manual then loses its magic, but regains it in a century.",
  },
  {
    id: 7,
    title: "Belt of Giant Strength",
    url: "https://www.dndbeyond.com/avatars/thumbnails/18/897/1000/1000/636381754971745722.png",
    originalPrice: 179.99,
    salePrice: 124.99,
    rating: 4,
    description: "While wearing this belt, your Strength score changes to a score granted by the belt. The item has no effect on you if your Strength without the belt is equal to or greater than the belt’s score. Six varieties of this belt exist, corresponding with and having rarity according to the six kinds of true giants. The belt of stone giant strength and the belt of frost giant strength look different, but they have the same effect.",
  },
  {
    id: 8,
    title: "Boots of Speed",
    url: "https://www.dndbeyond.com/avatars/thumbnails/7/136/1000/1000/636284714256851023.jpeg",
    originalPrice: 149.99,
    salePrice: 119.99,
    rating: 3.5,
    description: "While you wear these boots, you can use a bonus action and click the boots' heels together. If you do, the boots double your walking speed, and any creature that makes an opportunity attack against you has disadvantage on the attack roll. If you click your heels together again, you end the effect. When the boots' property has been used for a total of 10 minutes, the magic ceases to function until you finish a long rest.",
  },
  {
    id: 9,
    title: "Bag of Beans",
    url: "https://www.dndbeyond.com/avatars/thumbnails/7/116/1000/1000/636284707516440810.jpeg",
    originalPrice: 420.69,
    salePrice: 269.69,
    rating: 5,
    description: "Inside this heavy cloth bag are 3d4 dry beans. The bag weighs 1/2 pound plus 1/4 pound for each bean it contains. If you dump the bag's contents out on the ground, they explode in a 10-foot radius, extending from the beans. Each creature in the area, including you, must make a DC 15 Dexterity saving throw, taking 5d4 fire damage on a failed save, or half as much damage on a successful one. The fire ignites flammable objects in the area that aren't being worn or carried. If you remove a bean from the bag, plant it in dirt or sand, and then water it, the bean produces an effect 1 minute later from the ground where it was planted. The GM can choose an effect from the following table, determine it randomly, or create an effect.",
  },
  {
    id: 10,
    title: "Goggles of Night",
    url: "https://www.dndbeyond.com/avatars/thumbnails/7/235/1000/1000/636284736878181910.jpeg",
    originalPrice: 49.99,
    salePrice: null,
    rating: 3,
    description: "While wearing these dark lenses, you have darkvision out to a range of 60 feet. If you already have darkvision, wearing the goggles increases its range by 60 feet.",
  },
  {
    id: 11,
    title: "Horn of Valhalla",
    url: "https://www.dndbeyond.com/avatars/thumbnails/7/259/1000/1000/636284740704653038.jpeg",
    originalPrice: 309.99,
    salePrice: 240.99,
    rating: 5,
    description: "You can use an action to blow this horn. In response, warrior spirits from the Valhalla appear within 60 feet of you. They use the statistics of a berserker. They return to Valhalla after 1 hour or when they drop to 0 hit points. Once you use the horn, it can't be used again until 7 days have passed. Four types of horn of Valhalla are known to exist, each made of a different metal. The horn's type determines how many berserkers answer its summons, as well as the requirement for its use. The GM chooses the horn's type or determines it randomly.",
  },
  {
    id: 12,
    title: "Robe of Useful Items",
    url: "https://www.dndbeyond.com/avatars/thumbnails/7/384/1000/1000/636284764677563266.jpeg",
    originalPrice: 69.99,
    salePrice: 39.99,
    rating: 4,
    description: "This robe has cloth patches of various shapes and colors covering it. While wearing the robe, you can use an action to detach one of the patches, causing it to become the object or creature it represents. Once the last patch is removed, the robe becomes an ordinary garment.",
  },
];
